import { BridgeForm } from '@/components/bridge/BridgeForm'
import { Shield, Clock } from 'lucide-react'

export function HomePage() {
  return (
    <div className="min-h-[calc(100vh-180px)] flex items-center">
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center w-full max-w-6xl mx-auto">
        {/* Left Column - Info */}
        <div className="space-y-6 sm:space-y-8 lg:pr-8 order-2 lg:order-1">
          <div>
            <h1 className="heading text-3xl sm:text-4xl lg:text-5xl text-white mb-3 sm:mb-4">
              Bridge <span className="text-gradient">W2USDT</span>
            </h1>
            <p className="text-dark-300 text-base sm:text-lg">
              Convierte W2USDT de Uni2 a USDT en BSC de forma segura y rápida.
            </p>
            <p className="text-dark-500 text-sm mt-2">
              Convert W2USDT from Uni2 to USDT on BSC safely and quickly.
            </p>
          </div>

          {/* Features */}
          <div className="space-y-4">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-11 h-11 sm:w-12 sm:h-12 bg-uni-500/10 rounded-xl flex items-center justify-center flex-shrink-0 border border-uni-500/20">
                <Shield className="w-5 h-5 sm:w-6 sm:h-6 text-uni-400" />
              </div>
              <div className="min-w-0">
                <h3 className="font-semibold text-white">Seguro</h3>
                <p className="text-sm text-dark-400">Tokens bloqueados en contrato auditado hasta completar el bridge.</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-11 h-11 sm:w-12 sm:h-12 bg-uni-500/10 rounded-xl flex items-center justify-center flex-shrink-0 border border-uni-500/20">
                <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-uni-400" />
              </div>
              <div className="min-w-0">
                <h3 className="font-semibold text-white">Aprobación Manual</h3>
                <p className="text-sm text-dark-400">Todas las solicitudes son revisadas para mayor seguridad.</p>
              </div>
            </div>

          </div>
        </div>

        {/* Right Column - Bridge Form */}
        <div className="lg:pl-8 lg:border-l lg:border-dark-800/50 order-1 lg:order-2">
          <BridgeForm />
        </div>
      </div>
    </div>
  )
}
